export default "__VITE_ASSET__CiBKN2i4__"